import React, { useRef } from 'react';
import Odontograma from './Odontograma';

const VisorConsultaModal = ({ patient, quote, onCancel }) => {
    const printRef = useRef(null);

    if (!quote) return null;

    const patientName = quote.form?.nombre || `${patient?.first_name || ''} ${patient?.last_name || ''}`.trim().toUpperCase() || 'PACIENTE';
    const form = quote.form || {};
    const treatments = quote.treatments || [];
    const odontogramaData = quote.odontogramaData || {};

    const subtotalCost = treatments.reduce((acc, curr) => acc + ((parseFloat(curr.precio) || 0) * (parseInt(curr.cantidad) || 1)), 0);
    const discountPct = parseFloat(form.discountPercentage) || 0;
    const globalDiscountAmount = (subtotalCost * discountPct) / 100;
    const finalTotalCost = subtotalCost - globalDiscountAmount;

    const handlePrint = async () => {
        const html2pdf = (await import('html2pdf.js')).default;
        const input = document.getElementById("print-quote-modal-area");
        
        const opt = {
            margin: [5, 5, 5, 5],
            filename: `Presupuesto_${patientName}.pdf`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2, useCORS: true, scrollY: 0 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };
        
        try {
            await html2pdf().set(opt).from(input).save();
        } catch (error) {
            console.error("Error generando PDF del presupuesto", error);
        }
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 10000, overflowY: 'auto' }}>
            {/* Barra superior de control */}
            <div className="d-print-none sticky-top" style={{ backgroundColor: '#1e293b', padding: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
                <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    <i className="bi bi-file-earmark-medical-fill me-2 text-info"></i>
                    Presupuesto / Cotización de {patientName} ({quote.date})
                </span>
                <button onClick={handlePrint} className="btn btn-light fw-bold px-4 rounded-pill">
                    <i className="bi bi-printer-fill me-2"></i> Imprimir / PDF
                </button>
                <button onClick={onCancel} className="btn btn-danger fw-bold px-4 rounded-pill">
                    <i className="bi bi-x-circle-fill me-2"></i> Cerrar
                </button>
            </div>

            <style>
                {`
                    @media print {
                        body * { visibility: hidden; }
                        #print-quote-modal-area, #print-quote-modal-area * { visibility: visible !important; }
                        #print-quote-modal-area { position: absolute !important; left: 0 !important; top: 0 !important; width: 100% !important; margin: 0 !important; padding: 0 !important; box-shadow: none !important; }
                    }
                    .pill-table-modal { width: 100%; border-collapse: separate; border-spacing: 0 4px; font-size: 11px; text-align: center; }
                    .pill-table-modal th { padding: 3px; font-weight: 900; }
                    .pill-table-modal td { background-color: #dbeafe; padding: 4px; height: 24px; border-left: 2px solid white; border-right: 2px solid white; }
                    .pill-table-modal td:first-child { border-top-left-radius: 20px; border-bottom-left-radius: 20px; border-left: none; }
                    .pill-table-modal td:last-child { border-top-right-radius: 20px; border-bottom-right-radius: 20px; border-right: none; }
                `}
            </style>

            <div id="print-quote-modal-area" ref={printRef} style={{ width: '210mm', minHeight: '270mm', backgroundColor: 'white', margin: '20px auto', padding: '10mm', boxSizing: 'border-box', position: 'relative', fontFamily: "'Segoe UI', Roboto, sans-serif", boxShadow: '0 4px 15px rgba(0,0,0,0.2)', display: 'flex', flexDirection: 'column', borderRadius: '8px' }}>
                
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                    <img src="/biodentality.png" alt="Biodentality" style={{ maxHeight: '60px', objectFit: 'contain' }} />
                </div>

                {/* Título */}
                <div style={{ backgroundColor: '#e5e7eb', borderRadius: '40px', padding: '8px', textAlign: 'center', marginBottom: '10px' }}>
                    <h2 style={{ margin: 0, color: '#000', fontWeight: '900', fontSize: '18px' }}>PRESUPUESTO DE TRATAMIENTO ODONTOLÓGICO</h2>
                </div>

                {/* Form Fields */}
                <div style={{ border: '2px solid #93c5fd', borderRadius: '15px', padding: '10px 15px', marginBottom: '10px', fontSize: '12px', fontWeight: 'bold' }}>
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '8px' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '150px' }}>Nombre del paciente:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {patientName}
                            </div>
                        </div>
                        <div style={{ width: '250px', display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '60px' }}>Cédula:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.cedula || patient?.cedula || 'N/A'}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '15px', marginBottom: '8px' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '150px' }}>Nombre Rep.:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.representante || patient?.representative || '-'}
                            </div>
                        </div>
                        <div style={{ width: '250px', display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '140px' }}>Fecha de nacimiento:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.fechaNacimiento || patient?.birth_date || '-'}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '15px', marginBottom: '8px' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '150px' }}>C.I. Rep.:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.cedulaRepresentante || patient?.representative_cedula || '-'}
                            </div>
                        </div>
                        <div style={{ width: '250px', display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '70px' }}>Teléfono:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.telefono || patient?.phone || '-'}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '15px', marginBottom: '8px' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '150px' }}>Dirección:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.direccion || patient?.address || '-'}
                            </div>
                        </div>
                        <div style={{ width: '250px', display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '80px' }}>Ocupación:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.ocupacion || patient?.occupation || '-'}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '15px' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '150px' }}>Correo:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center' }}>
                                {form.correo || patient?.email || '-'}
                            </div>
                        </div>
                        <div style={{ width: '250px', display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '80px' }}>Inversión:</span>
                            <div style={{ flex: 1, backgroundColor: '#dbeafe', borderRadius: '20px', padding: '4px 15px', minHeight: '26px', display: 'flex', alignItems: 'center', fontWeight: 'bold', color: '#003d80' }}>
                                {(form.inversion || quote.diagnostic_plans?.inversion) ? ((form.inversion || quote.diagnostic_plans?.inversion).toString().startsWith('$') ? (form.inversion || quote.diagnostic_plans?.inversion) : `$ ${(form.inversion || quote.diagnostic_plans?.inversion)}`) : '-'}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Odontograma */}
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '320px' }}>
                    <div style={{ transform: 'scale(0.70)', transformOrigin: 'top center', minWidth: '950px', display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
                        <Odontograma data={odontogramaData} onChange={() => {}} shape="circle" />
                    </div>
                </div>

                {/* Tabla de tratamientos */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '900' }}>PLAN DE TRATAMIENTO</h3>
                </div>
                <table className="pill-table-modal">
                    <thead>
                        <tr>
                            <th style={{ width: '10%' }}>N°</th>
                            <th style={{ width: '45%' }}>PROCEDIMIENTO</th>
                            <th style={{ width: '15%' }}>CANTIDAD</th>
                            <th style={{ width: '15%' }}>PRECIO UNITARIO</th>
                            <th style={{ width: '15%' }}>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {treatments.map((t, i) => (
                            <tr key={i}>
                                <td style={{ fontWeight: 'bold' }}>{i + 1}</td>
                                <td style={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '15px' }}>{t.procedimiento || '-'}</td>
                                <td>{t.cantidad || 1}</td>
                                <td>${parseFloat(t.precio || 0).toFixed(2)}</td>
                                <td style={{ fontWeight: 'bold' }}>
                                    ${(t.total_final !== undefined ? parseFloat(t.total_final) : ((parseFloat(t.precio) || 0) * (parseInt(t.cantidad) || 1))).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                        {[...Array(Math.max(0, 3 - treatments.length))].map((_, i) => (
                            <tr key={`empty-${i}`}>
                                <td></td><td></td><td></td><td></td><td></td>
                            </tr>
                        ))}
                        <tr style={{ backgroundColor: 'transparent' }}>
                            <td colSpan="3" style={{ backgroundColor: 'transparent', paddingRight: '15px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: '900', fontSize: '14px' }}>
                                    <span>SUBTOTAL</span>
                                </div>
                            </td>
                            <td colSpan="2" style={{ fontWeight: '900', fontSize: '14px', backgroundColor: 'transparent', textAlign: 'center' }}>
                                ${subtotalCost.toFixed(2)}
                            </td>
                        </tr>
                        
                        <tr style={{ backgroundColor: 'transparent' }}>
                            <td colSpan="3" style={{ backgroundColor: 'transparent', paddingRight: '15px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: '900', fontSize: '14px' }}>
                                    <span>DESCUENTO {discountPct > 0 ? `(${discountPct}%)` : ''}</span>
                                </div>
                            </td>
                            <td colSpan="2" style={{ fontWeight: '900', fontSize: '14px', backgroundColor: 'transparent', textAlign: 'center' }}>
                                ${globalDiscountAmount.toFixed(2)}
                            </td>
                        </tr>
                        
                        <tr style={{ backgroundColor: 'transparent' }}>
                            <td colSpan="3" style={{ backgroundColor: 'transparent', paddingRight: '15px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: '900', fontSize: '14px' }}>
                                    <span>TOTAL A PAGAR</span>
                                </div>
                            </td>
                            <td colSpan="2" style={{ fontWeight: '900', fontSize: '14px', backgroundColor: 'transparent', textAlign: 'center' }}>
                                ${finalTotalCost.toFixed(2)}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Footer */}
                <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', backgroundColor: '#e5e7eb', borderRadius: '30px', padding: '8px 20px', alignItems: 'center' }}>
                    <div style={{ fontSize: '10px', fontWeight: 'bold', display: 'flex', gap: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#16a34a' }}>
                            <i className="bi bi-whatsapp"></i> CONTÁCTANOS: 0991362188
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#002b5e' }}>
                            <i className="bi bi-geo-alt-fill"></i> DIRECCIÓN: SUCRE Y VENEZUELA ESQUINA (CARCHI-TULCÁN)
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default VisorConsultaModal;
